import React, { useEffect, useState } from 'react';
import { getArtistDiscovery } from 'actions/artist';
import PageContentContainer from 'components/PageContentContainer';
import ArtistList from 'components/ArtistList';
import { Box, Typography, Divider } from '@mui/material';
import SearchBar from 'components/SearchBar/SearchBar';

const ArtistDiscovery = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    const getData = async () => {
      const data = await getArtistDiscovery();
      setData(data);
    };
    getData();
  }, []);

  return (
    <PageContentContainer breadcrumb="discover" heading="Artists">
      <Box pt={2} pb={2}>
        <Typography component="h2" variant="h4" gutterBottom>
          Search
        </Typography>
        <SearchBar />
        <Box pt={4} pb={2}>
          <Divider />
        </Box>
      </Box>
      {!!data?.trending?.length && (
        <Box pt={2} pb={2}>
          <Typography component="h2" variant="h4" gutterBottom>
            Trending
          </Typography>
          <ArtistList artists={data.trending} />
        </Box>
      )}
      {!!data?.latest?.length && (
        <Box pt={2} pb={2}>
          <Typography component="h2" variant="h4" gutterBottom>
            Recently added
          </Typography>
          <ArtistList artists={data.latest} />
        </Box>
      )}
      {!!data?.top?.length && (
        <Box pt={2} pb={2}>
          <Typography component="h2" variant="h4" gutterBottom>
            Popular
          </Typography>
          <ArtistList artists={data.top} cols={3} />
        </Box>
      )}
    </PageContentContainer>
  );
};

export default ArtistDiscovery;
